import React, { useState, useEffect } from 'react';
import ActionButtonCard from '../Button/ActionButtonCard';
import { useProvider, Toast } from '../../context/MenuProvider';
import Swal from 'sweetalert2'
import { Form, Button, Card, InputGroup, FormControl } from 'react-bootstrap';

function  SelecionarTipoDeContato({tipoDeContatoId,  setTipoDeContatoId, defaultValue, defaultText, label, adicionalText, adicionalValue, search}) {
  const [tipos, setTipos] = useState([]);
  const {
    crudAdmin,
  } = useProvider();
  const { get } = crudAdmin || {};

  


  const buscarTipos = async () => {
    try{
      const urls = [
        `/assistente-ia/relacionamento/?ordering=titulo&search=${search || ''}&limit=100`,
      ];
      const response = await get(urls, 'SelecionarTipoDeContato');
      if (response){
        setTipos(response[0].results);
      }
    }catch(err){
      
    }finally{

    }
  };
  
  

  useEffect(() => {
    buscarTipos();
  }, [setTipos]);

  return (
    <>
      <Form.Group controlId="formCategoria" className="mt-3">
        <Form.Label>{label || 'Tipo'}</Form.Label>
        <Form.Control 
          as="select" 
          value={ tipoDeContatoId} 
          onChange={(e) =>  setTipoDeContatoId(e.target.value)}
        >
          {/* Supondo que você tenha um array de tipos para mapear */}
          {defaultText &&(
            <option value={defaultValue||''}>{defaultText || ''}</option>
          )}
          {adicionalText &&(
            <option value={adicionalValue}>{adicionalText || ''}</option>
          )}
          {/* Categorias mapeadas aqui */}
          {tipos.length > 0 ? (tipos.map((item) => 
            <option value={item.contexto}>{item.titulo}</option>
          )) : ''}
        </Form.Control>
      </Form.Group>
    </>
  );
}

export default  SelecionarTipoDeContato;